<template>
  <div :class="['page', { 'new-ui': newUI }]">
    <slot name="header"></slot>
    <div :class="[type === 'detail' ? 'main':'main mainList']">
      <slot></slot>
    </div>
    <slot name="footer"></slot>
  </div>
</template>
<script>
export default {
  name: 'Page',
  props: {
    newUI: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      type: ''
    }
  },
  created () {
    console.log(this.$route.name)
    let isAndroidV = false
    if (navigator.userAgent.indexOf('ndroid') > 0) {
      let androidV = parseFloat(navigator.userAgent.slice(navigator.userAgent.indexOf('ndroid') + 7))
      console.log(androidV, '版本')
      if (androidV < 7.2) {
        console.log(androidV)
        isAndroidV = true
      }
    }
    if ((this.$route.name === 'record-applicant-detail' || this.$route.name === 'direct-lead-detail' || this.$route.name === 'each-principal-detail' || this.$route.name === 'applicant-detail' || this.$route.name === 'garden-detail' || this.$route.name ===
      'record-detail' || this.$route.name === 'record-leader-detail' || this.$route.name === 'message-detail' || this.$route.name === 'train-detail' || this.$route.name === 'applicant' || this.$route.name === 'each-principal' || this.$route.name === 'index') && isAndroidV === true) {
      this.type = 'detail'
    } else {
      this.type = 'list'
    }
  }
}
</script>
<style lang="scss" scoped>
.page
{
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  .main
  {
    position: relative;
    //flex: 1;
    //display: flex;
    //flex-direction: column;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .loadmore-wrapper
    {
      flex: 1;
      position: relative;
      width: 100%;
      overflow: hidden;
      .no-data
      {
        position: absolute;
        top: 45%;
        left: 0px;
        width: 100%;
        transform: translateY(-50%);
      }
    }
  }
  .mainList
  {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
}
.van-dropdown-menu{
  height: 50px;
  position: relative;
  z-index: 99999;
}
::v-deep .approve-basic .row{
  // display: block !important;

}
::v-deep .approve-basic .row label{
  display: inline-block !important;
  width: 100px !important;
}
::v-deep .approve-basic .row .dynamic-field-view{
  display: inline-block !important;
}

::v-deep .approve-room .row{
  // display: block !important;

}
::v-deep .approve-room .row label{
  display: inline-block !important;
  width: 100px !important;
}
::v-deep .approve-room .row .dynamic-field-view{
  display: inline-block !important;
}

::v-deep .approve-catering .row{
  // display: block !important;
}
::v-deep .approve-catering .row label{
  display: inline-block !important;
  width: 100px !important;
}
::v-deep .approve-catering .row .dynamic-field-view{
  display: inline-block !important;
}

::v-deep .approve-hotel .row{
  // display: block !important;

}
::v-deep .approve-hotel .row label{
  display: inline-block !important;
  width: 100px !important;
}
::v-deep .approve-hotel .row .dynamic-field-view{
  display: inline-block !important;
}

::v-deep .approve-visit .row{
  display: block !important;

}
::v-deep .approve-visit .row label{
  display: inline-block !important;
  width: 100px !important;
}
</style>
<style lang="less">
// 适配新UI
.page.new-ui
{
  background: #F7F7F7;
  .loadmore-header,
  .loadmore-footer
  {
    color: #333!important;
  }
  .van-dropdown-menu__bar
  {
    background-color: #fff;
    .van-dropdown-menu__title
    {
      color: rgba(0,0,0,0.9);
    }
  }
  .van-dropdown-menu .van-popup
  {
    background-color: #fff;
    .van-cell
    {
      background-color: #fff;
      color: rgba(0,0,0,0.9);
      .van-icon-success
      {
        color: rgba(0,0,0,0.9);
      }
    }
  }
  .van-search
  {
    background-color: #fff!important;
    .van-search__content--round
    {
      background: #F7F8FA;
    }
    .van-field__left-icon,
    .van-field__value
    {
      color: #C8C9CC;
    }
    .van-field__control
    {
      color: #333;
    }
  }
  .van-dialog
  {
    background-color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/index.vue